import TextAreaList from "./TextAreaList";

export default TextAreaList;

export { TextAreaList };
